export default __webpack_public_path__ + "static/media/01_user.8f8ec410.svg";